<template>
  <div class="h-full p-20px">
    <div class="flex flex-column h-full">
      <vxe-toolbar class-name="px-16px" :loading="loading">
        <template #buttons>
          <Select ref="subject" :datas="subjectList" keyName="id" titleName="fullName"
                  v-model="params.subjectId" @change="subjectChange" :deletable="false" style="margin-right:16px;">
            <template #show="{value}">
              {{ value.code }} {{ value.fullName }}
            </template>
            <template #item="{item}">
              {{ item.code }} {{ item.fullName }}
            </template>
          </Select>
          <DropdownCustom ref="stateParamsDropdown" button class="h-btn-primary" trigger="click">
            <div>{{ params.billDate.start }} 至 {{ params.billDate.end }}</div>
            <template #content>
              <Form style="padding: 10px" :labelWidth="90">
                <FormItem class="!pb-5px" label="银行科目">
                  <Select ref="subject" :datas="subjectList" keyName="id" titleName="fullName"
                          v-model="params.subjectId" @change="subjectChange" :deletable="false">
                    <template #show="{value}">
                      {{ value.code }} {{ value.fullName }}
                    </template>
                    <template #item="{item}">
                      {{ item.code }} {{ item.fullName }}
                    </template>
                  </Select>
                </FormItem>
                <FormItem class="!pb-5px" label="交易日期">
                  <div class="flex items-center">
                    <DatePicker v-model="params.billDate.start" :clearable="false" :option="{end:params.billDate.end}"/>
                    <span class="mx-8px">至</span>
                    <DatePicker v-model="params.billDate.end" :clearable="false" :option="{start:params.billDate.start}"/>
                  </div>
                </FormItem>
                <FormItem class="!pb-5px" label="交易流水号">
                  <Input v-model="params.billNo"/>
                </FormItem>
                <FormItem class="!pb-5px" label="对方户名">
                  <Input v-model="params.opposingAccountName"/>
                </FormItem>
                <FormItem class="!pb-5px" label="交易备注">
                  <Input v-model="params.comments"/>
                </FormItem>
<!--                <FormItem class="!pb-10px" label="金额">-->
<!--                  <div class="flex items-center">-->
<!--                    <NumberInput v-model="params.minMoney"/>-->
<!--                    <span class="mx-8px">至</span>-->
<!--                    <NumberInput v-model="params.maxMoney"/>-->
<!--                  </div>-->
<!--                </FormItem>-->
                <FormItem class="!pb-10px" label="收入金额">
                  <div class="flex items-center">
                    <NumberInput v-model="params.minInAmount"/>
                    <span class="mx-8px">至</span>
                    <NumberInput v-model="params.maxInAmount"/>
                  </div>
                </FormItem>
                <FormItem class="!pb-10px" label="支出金额">
                  <div class="flex items-center">
                    <NumberInput v-model="params.minOutAmount"/>
                    <span class="mx-8px">至</span>
                    <NumberInput v-model="params.maxOutAmount"/>
                  </div>
                </FormItem>
                <FormItem class="!pb-5px">
                  <Button color="primary" @click="reSearch();" :loading="loading">确定</Button>
                  <Button @click="this.$refs.stateParamsDropdown.hide()">取消</Button>
                  <Button @click="resetForm">重置</Button>
                </FormItem>
              </Form>
            </template>
          </DropdownCustom>
        </template>
        <template #tools>
<!--          <Checkbox v-model="showAll" class="mr-16px">显示全部</Checkbox>-->

          <Button @click="importStatement">导入</Button>
          <Button @click="exportStatement">导出</Button>

          <template v-if="User.role!=='View'">
            <DropdownMenu button @clickItem="trigger" :datas="{batchDelete:'删除选中',deleteAll:'删除全部'}">删除</DropdownMenu>
          </template>

<!--          <DropdownMenu-->
<!--              button-->
<!--              trigger="hover"-->
<!--              @clickItem="batchClickItem"-->
<!--              :datas="{batchDelete:'批量删除'}">-->
<!--            批量操作-->
<!--          </DropdownMenu>-->
        </template>
      </vxe-toolbar>
      <div class="flex-1 h-0px">
<!--        <vxe-table ref="bankStatementTable"-->
<!--                   :checkbox-config="{visibleMethod:({ row }) => !row.init,checkMethod:({ row }) => !row.init}"-->
<!--                   :loading="loading"-->
<!--                   :data="datas"-->
<!--                   height="auto"-->
<!--                   border>-->
<!--          <vxe-column type="checkbox" width="50" align="center" fixed="left"/>-->
<!--          <vxe-column title="交易日期" field="billDate" width="120"/>-->
<!--          <vxe-column title="交易时间戳" field="billTimestamp" width="160"/>-->
<!--          <vxe-column title="收入金额" field="inAmount" width="100" align="right"/>-->
<!--          <vxe-column title="支出金额" field="outAmount" width="100" align="right"/>-->
<!--          <vxe-column title="本次余额" field="currentBalance" width="120" align="right"/>-->
<!--          <vxe-column title="手续费总额" field="serviceCharge" :visible="showAll" width="100" align="right"/>-->
<!--          <vxe-column title="交易方式" field="billType" :visible="showAll" width="100"/>-->
<!--          <vxe-column title="交易行名" field="billBankName" :visible="showAll" width="100"/>-->
<!--          <vxe-column title="交易类别" field="billCategory" :visible="showAll" width="100"/>-->
<!--          <vxe-column title="对方省市" field="opposingProvince" :visible="showAll" width="100"/>-->
<!--          <vxe-column title="对方账号" field="opposingAccount" width="100"/>-->
<!--          <vxe-column title="对方户名" field="opposingAccountName" width="100"/>-->
<!--          <vxe-column title="交易说明" field="description" :visible="showAll" width="100"/>-->
<!--          <vxe-column title="交易摘要" field="summary" :visible="showAll" width="100"/>-->
<!--          <vxe-column title="交易附言" field="comments" width="260"/>-->
<!--          <vxe-column title="交易日志号" field="billNo" width="100"/>-->

<!--          <vxe-column title="操作" width="120">-->
<!--            <template #default="{row}">-->
<!--              <div class="actions" v-if="!row.init && !row.cashierTransferId">-->
<!--                <span v-if="!row.voucherId" @click="doTrash(row)" class="fa fa-trash">删除</span>-->
<!--              </div>-->
<!--            </template>-->
<!--          </vxe-column>-->
<!--        </vxe-table>-->

        <vxe-table ref="bankStatementTable"
                   :loading="loading"
                   :row-config="{isCurrent: true, isHover: true}"
                   :scroll-y="{enabled: true}"
                   :checkbox-config="{trigger: 'row', highlight: true, range: true}"
                   :data="datas"
                   height="auto"
                   border>
          <vxe-column type="checkbox" width="55" align="center"></vxe-column>
          <vxe-column title="对账" width="100" align="center">
            <template #default="{ row }">
              <vxe-icon name="check" v-if="row.hasOwnProperty('reconciliationId') && row.reconciliationId!=null"></vxe-icon>
            </template>
          </vxe-column>
          <vxe-column title="交易日期" field="billDate" width="120"/>
          <vxe-column title="收入金额" field="inAmount" width="120" align="right">
            <template #default="{ row }">
              {{ numFormat(row.inAmount) }}
            </template>
          </vxe-column>
          <vxe-column title="支出金额" field="outAmount" width="120" align="right">
            <template #default="{ row }">
              {{ numFormat(row.outAmount) }}
            </template>
          </vxe-column>
          <vxe-column title="本次余额" field="currentBalance" width="120" align="right">
            <template #default="{ row }">
              {{ numFormat(row.currentBalance) }}
            </template>
          </vxe-column>
          <vxe-column title="交易备注" field="comments" width="260" align="center"/>
                    <vxe-column title="对方账号" field="opposingAccount" width="100"/>
          <vxe-column title="对方户名" field="opposingAccountName" width="100" align="center"/>
          <vxe-column title="对方开户行" field="opposingBankName" width="130" align="center"/>
          <vxe-column title="交易流水号" field="billNo" width="220" align="center"/>
          <vxe-column v-if="currentAccountSets.intelligentReconciliation" title="退据号" field="refundNo" width="160" align="center" />
          <vxe-column title="交易时间" field="billTime" width="160"/>
        </vxe-table>

      </div>
      <vxe-pager @page-change="currentPageChange"
                 v-model:current-page="pagination.page"
                 v-model:page-size="pagination.pageSize"
                 :total="pagination.total"
                 :layouts="['Sizes', 'PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'FullJump', 'PageCount', 'Total']">
        <template #left>
          <vxe-button @click="loadList()" type="text" size="mini" icon="fa fa-refresh" :loading="loading"></vxe-button>
        </template>
      </vxe-pager>
    </div>
  </div>
</template>

<script>
import {ref, h, watch, reactive} from "vue";
import Qs from "qs";
import {mapActions, mapGetters, mapState} from 'vuex'
import {clone, pick} from "xe-utils";
import {layer} from "@layui/layer-vue";
import manba from "manba";
import voucher from "@api/voucher";
import BankStatement from "@api/BankStatement";
import {downloadBlob} from "download.js";
import {confirm, message, modal} from "heyui.ext";
import StatementImport from "@/views/reconciliation/StatementImport";
import CashierJournal from "@api/CashierJournal";
import CashierJournalBatchUpdate from "@/views/cashier/CashierJournalBatchUpdate";
import setting from "@api/setting";
import accountbook from "@api/accountbook";

export default {
  name: "BankStatement",
  data() {
    return {
      datas: [],
      showAll: false,
      accountDate: null,
      pagination: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      subjectName: "",
      subject: [],
      subjectList: [],
      params: {
        subjectId: null,
        billDate: {start: null, end: null},
        billNo: "",
        comments: "",
        opposingAccountName: "",
        minInAmount: null,
        maxInAmount: null,
        minOutAmount: null,
        maxOutAmount: null
      },
      loading: false,
      checkAll: false,
      param: [{title: '打印全部', key: 'printAll'}, {title: '打印选中', key: 'printCheck'}]
    };
  },
  watch: {
    checkAll(nval) {
      let data = Array.from(this.datas);
      data.forEach(val => val._checked = nval);
      this.datas = data;
    },
    showAll(nval) {
      setTimeout(() => {
        this.$refs.bankStatementTable.refreshColumn();
      }, 200)
    }
  },
  computed: {
    ...mapState(['User', 'currentAccountSets']),
    ...mapGetters(['checkoutSelect', 'localCurrency']),
    date() {
      return manba(this.accountDate);
    },
    billdateRange() {
      if (!this.params.billDate.start) {
        return '';
      }
      if (this.params.billDate.start === this.params.billDate.end) {
        return manba(this.params.billDate.start).format("YYYYMMDD")
      }
      return manba(this.params.billDate.start).format("YYYYMMDD") + " - " + manba(this.params.billDate.end).format("YYYYMMDD");
    },
  },
  methods: {
    ...mapActions(['init']),
    subjectChange(subject) {
      this.subjectName = subject.fullName;
      this.subject = subject;
      this.initPagination();
      this.loadList();
    },
    currentPageChange() {
      this.loadList();
    },
    trigger(key) {
      this[key].call(this);
    },
    downloadTrigger(key) {
      if (key === 'all') {
        voucher.download(this.params).then((data) => {
          downloadBlob(this.currentAccountSets.companyName + (manba().format('YYYYMMDDHHmmss')) + "凭证.xlsx", data);
        })
      } else {
        let checked = this.datas.filter(value => value._checked);
        if (checked.length) {
          voucher.download({id: checked.map(value => value.id)}).then((data) => {
            downloadBlob(this.currentAccountSets.companyName + (manba().format('YYYYMMDDHHmmss')) + "凭证.xlsx", data);
          })
        } else {
          this.$Message("未选择记录");
        }
      }
    },
    printAll() {
      let param = Qs.stringify({audit: this.params.audit, voucherDateStart: this.params.voucherDate.start, voucherDateEnd: this.params.voucherDate.end}, {indices: false});
      window.open(`/api/pdf/voucher?${param}`);
    },
    printCheck() {
      let checked = this.datas.filter(value => value._checked);
      if (checked.length) {
        let param = Qs.stringify({id: checked.map(value => value.id)}, {indices: false});
        window.open(`/api/pdf/voucher?${param}`);
      } else {
        this.$Message("未选择记录");
      }
    },
    loadBankSubjectList(){
      return setting.subject.bankList().then(({data}) => {
        this.subjectList = data;
        if(this.subjectList.length>0){
          this.params.subjectId = this.subjectList[0].id;
          this.subjectName = this.subjectList[0].fullName;
          this.subject = this.subjectList[0];
        }
      });
    },
    initPagination(){
      this.pagination = {
        page: 1,
        pageSize: 20,
        total: 0
      };  //初始化页码
    },
    reSearch(){
      this.initPagination();
      this.loadList();
    },
    loadList() {
      const loadId = layer.load(2);
      BankStatement.list(this.pagination, this.params).then(({data}) => {
        this.datas = data.results || [];
        this.pagination = {
          page: data.page,
          pageSize: data.pageSize,
          total: data.total
        }
      }).finally(() => {
        layer.close(loadId);
        this.$refs.stateParamsDropdown.hide();
      })
    },
    remove(row) {
      this.$Confirm("确认删除?").then(() => {
        const loadId = layer.load(2);
        BankStatement.delete([pick(row, ['id', 'year', 'month'])]).then(({data}) => {
          if (data && data.length) {
            this.$Message("部分删除不成功，请检查所在账期是否已结账~")
          } else {
            this.$Message("删除成功~")
            this.init();
          }

          this.initPagination();
          this.loadList();
        }).finally(() => layer.close(loadId))
      });
    },
    doTrash(row) {
      confirm({
        content: `确认删除此记录?`,
        onConfirm: () => {
          loading.value = true;
          BankStatement.delete(row.id).then(() => {
            this.initPagination();
            loadList();
          }).finally(() => loading.value = false)
        }
      })
    },
    batchDelete() {
      let records = this.$refs.bankStatementTable.getCheckboxRecords().map(row => row.id);

      if (records.length) {
        confirm({
          content: `确认删除这些记录?`,
          onConfirm: () => {
            this.loading = true;
            BankStatement.batchDelete(records).then(({data}) => {
              this.$Message("已刪除 "+data+" 条记录！");
              this.initPagination();
              this.loadList();
            }).finally(() => this.loading = false)
          }
        })
      } else {
        message.warn("请选择记录~");
      }
    },
    deleteAll() {

      this.$Confirm("确认删除已筛选的全部记录?").then(() => {
        const loadId = layer.load(2);
        BankStatement.deleteAll(this.params).then(({data}) => {
          this.$Message("已刪除 "+data+" 条记录！");
          this.initPagination();
          this.loadList();
        }).finally(() => {
          layer.close(loadId);
        });
      });
    },
    exportStatement(){
      const params = Object.assign({}, this.params);
      let filename = `${this.subject.code}${this.subject.fullName}-银行对账单(${this.billdateRange}).xls`
      BankStatement.downloadDetails(params).then((data) => {

        downloadBlob(filename, data)
      })
    },
    importStatement() {
      let layerId = layer.open({
        title: "银行对账单导入",
        shadeClose: false,
        closeBtn: false,
        zIndex: 1000,
        area: ['500px', 'auto'],
        content: h(StatementImport, {
          subjectList: this.subjectList,
          subjectValue: this.params.subjectId,
          onClose: () => {
            layer.close(layerId);
          },
          onSuccess: () => {
            layer.close(layerId);
            this.reSearch();
            layer.close(layerId);
          }
        })
      });
    },
    batchClickItem(type){
      let records = this.$refs.bankStatementTable.getCheckboxRecords().map(row => row.id);
      if (records.length) {
        switch (type) {
          case 'batchDelete':
            confirm({
              content: `确认删除这些记录?`,
              onConfirm: () => {
                this.loading = true;
                BankStatement.batchDelete(records).then(() => {
                  this.initPagination();
                  this.loadList();
                }).finally(() => this.loading = false)
              }
            })
            break
          case 'setIoType':
          case 'setAccountingCategory':
          case 'setProject':

        }
      } else {
        message("请选择需要操作的记录~")
      }
    },


    resetForm() {
      this.params = clone(this.cloneParams, true)
    }
  },
  created() {
    const currentAccountDate = manba(this.currentAccountSets.currentAccountDate);
    const startDate = ref(currentAccountDate.startOf(manba.MONTH).format());
    const endDate = ref(currentAccountDate.endOf(manba.MONTH).format());
    this.params.billDate.start = startDate;
    this.params.billDate.end = endDate;
    this.cloneParams = clone(this.params, true);
    this.loadBankSubjectList().then(() =>{
      this.loadList();
    })

  }
};
</script>